import { render, staticRenderFns } from "./CikkAdminLink.vue?vue&type=template&id=33304478&"
import script from "./CikkAdminLink.vue?vue&type=script&lang=js&"
export * from "./CikkAdminLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports